module.exports = __webpack_public_path__ + "img/symbol_13_x100.b326f508.png";